import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

type Props = {
	title: string;
	children: React.ReactNode;
};

export const StaffDrawerSection: React.FC<Props> = ({ title, children }) => (
	<section className="px-4 py-3">
		<Text as="h3" variant="body" size="x-small" fontWeight="bold" className="text-typography-weak mb-2 block uppercase">
			{title}
		</Text>
		<ul className="flex flex-col gap-1.5">{children}</ul>
	</section>
);
